import deMessages from './messages-de';

angular
  .module('blocks.i18n')
  .service('messagesDeService', messagesDeService);

function messagesDeService() {
  this.messages = deMessages;
}
